const ASSETS = {
  link: require('./images/Link.png'),
  ethereum: require('./icons/ethereum.svg').default,
  block: require('./icons/block.svg').default,
  arrowRight: require('./icons/arrow-right.svg').default,
  transaction: require('./icons/transaction.svg').default,
  logo: require('./icons/logo.svg').default,
  user: require('./icons/user.svg').default,
  logoWhite: require('./icons/logo-white.svg').default,
  info: require('./icons/info.svg').default,
  infoGrey: require('./icons/info-grey.svg').default,
  hourGlass: require('./icons/hour-glass.svg').default,
  clock: require('./icons/clock.svg').default,
  volt: require('./icons/volt.svg').default,
  check: require('./icons/check.svg').default,
  address: require('./icons/address.svg').default,
  copyAddress: require('./icons/Copy Address.svg').default,
  message: require('./icons/message.svg').default,
  qrCode: require('./icons/QR Code.svg').default,
  downArrow: require('./icons/down-arrow.svg').default,
  pen: require('./icons/pen.svg').default,
  navigator: require('./icons/navigator.svg').default,
  lightInfo: require('./icons/info-light.svg').default,
  eth: require('./icons/eth.svg').default,
  threedots: require('./icons/threedot.svg').default,
  star: require('./icons/star.svg').default,
  blackArrowDown: require('./icons/black-arrow-down.png'),
  wallet: require('./icons/wallet.svg').default,
  advanceFilter: require('./icons/advance-filter.svg').default,
  tableList: require('./icons/table-list.svg').default,
  download: require('./icons/download.svg').default,
  tableFilter: require('./icons/table-filter.svg').default,
  tableInfo: require('./icons/table-info.svg').default,
  eye: require('./icons/eye.svg').default,
  copy: require('./icons/copy.svg').default,
  light: require('./icons/light.svg').default,
  waves: require('./images/waves.png'),
  arrowDown: require('./icons/arrow-down.svg').default,
  search: require('./icons/search.svg').default,
  b: require('./icons/b.svg').default,
  globe: require('./icons/globe.svg').default,
  txs: require('./icons/txs.svg').default,
  meter: require('./icons/meter.svg').default,
  sortBy: require('./icons/sortBy.svg').default,
  chevronLeft: require('./icons/chevron-left.svg').default,
  chevronRight: require('./icons/chevron-right.svg').default,
  bulb: require('./icons/bulb.svg').default,
  checklist: require('./icons/checkList.svg').default,
  triangle: require('./icons/triangle.svg').default,
  rite: require('./icons/rite.svg').default,
  draft: require('./icons/draft.svg').default,
  account: require('./icons/acount.svg').default,
  barcode: require('./icons/barcode.svg').default,
  msg: require('./icons/msg.svg').default,
  tag: require('./icons/tag.svg').default,
  redirect: require('./icons/redirect.svg').default,
  arrowDownList: require('./icons/arrow-down-list.svg').default,
  cone: require('./icons/code.svg').default,
  infoLight: require('./icons/infoLight.svg').default,
  searchGrey: require('./icons/search-grey.svg').default,
};

export default ASSETS;
